import React, { useMemo } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { RowItemWrapper } from './ContributionActivitiesList.styles';

export enum HeadersKey {
  name = 'name',
  account = 'account',
  eeAmount = 'eeAmount',
  erAmount = 'erAmount',
  date = 'date',
  taxYear = 'taxYear',
  taxType = 'taxType',
  status = 'status',
  memo = 'memo',
  editActions = 'editActions',
}

export const HEADERS_VIEW = {
  [HeadersKey.name]: {
    title: 'Name',
    width: '108px',
  },
  [HeadersKey.account]: {
    title: 'Account',
    width: '110px',
  },
  [HeadersKey.eeAmount]: {
    title: 'EE amount',
    width: '110px',
  },
  [HeadersKey.erAmount]: {
    title: 'ER amount',
    width: '110px',
  },
  [HeadersKey.date]: {
    title: 'Date',
    width: '100px',
  },
  [HeadersKey.taxYear]: {
    title: 'Tax year',
    width: '70px',
  },
  [HeadersKey.taxType]: {
    title: 'Tax type',
    width: '70px',
  },
  [HeadersKey.status]: {
    title: 'Status',
    width: '95px',
  },
  [HeadersKey.memo]: {
    title: 'Memo',
    width: '109px',
  },
};

export const HEADERS_EDIT = {
  [HeadersKey.name]: {
    title: 'Name',
    width: '118px',
  },
  [HeadersKey.account]: {
    title: 'Account',
    width: '100px',
  },
  [HeadersKey.eeAmount]: {
    title: 'Employee amount',
    width: '150px',
  },
  [HeadersKey.erAmount]: {
    title: 'Employer amount',
    width: '150px',
  },
  [HeadersKey.date]: {
    title: 'Date',
    width: '160px',
  },
  [HeadersKey.taxYear]: {
    title: 'Tax year',
    width: '60px',
  },
  [HeadersKey.taxType]: {
    title: 'Tax type',
    width: '70px',
  },
  [HeadersKey.memo]: {
    title: 'Memo',
    width: '109px',
  },
  [HeadersKey.editActions]: {
    title: '',
    width: '89px',
  },
};

export const HeaderOfList: React.FC<{ isEditMode: boolean }> = ({ isEditMode }) => {
  const headers = useMemo(() => (isEditMode ? HEADERS_EDIT : HEADERS_VIEW), [isEditMode]);

  return (
    <Box
      height="32px"
      background="legend"
      round="container2Round"
      justify="center"
      pad={{ horizontal: 'spacing16' }}
    >
      <RowItemWrapper direction="row">
        {Object.entries(headers).map(([key, item]) => (
          <Box width={{ width: item.width, max: item.width }} key={key}>
            <Inscription
              size="small"
              weight="bold"
              lineHeight="normal"
              color="textBody"
              {...(key === 'status' ? { textAlign: 'end' } : {})}
            >
              {item.title}
            </Inscription>
          </Box>
        ))}
      </RowItemWrapper>
    </Box>
  );
};
